import ReactGA from 'react-ga4';
import { Select, MenuItem, SelectChangeEvent, InputLabel, FormControl, Box, Tooltip, ListSubheader, Divider, Typography } from '@mui/material';
import { useStore } from 'react-admin';
import { DistributionDataType, MapAttribute, MapAttributeType } from '../../models/map-attribute';
import { useEffect } from 'react';
import { mapAttributeItem, MapAttributeMenuItem } from './map-attribute-menu-item';


export const MapAttributeSelect = ({ mapAttributeList, defaultMapAttribute }: { mapAttributeList: MapAttribute[], defaultMapAttribute: MapAttributeType }) => {
  const [mapAttributeType, setMapAttributeType] = useStore<MapAttributeType>('map.mapAttribute.id', defaultMapAttribute);
  const [, setMapAttributeDataType] = useStore<DistributionDataType>('map.mapAttribute.dataType', 'number');
  const [mapAttributeName, setMapAttributeName] = useStore<string>('map.mapAttribute.name', '');

  const setMapAttribute = (mapAttribute: MapAttribute) => {
    setMapAttributeType(mapAttribute.type);
    setMapAttributeDataType(mapAttribute.dataType || 'number');
    setMapAttributeName(mapAttribute.name);
  }

  useEffect(() => {
    if (mapAttributeList.length > 0 && mapAttributeName === '') {
      const mapAttribue = mapAttributeList.find((a) => a.type === mapAttributeType);
      if (mapAttribue) {
        setMapAttribute(mapAttribue);
      }
    }
    if (mapAttributeList.length > 0 && !mapAttributeList.find((a) => a.type === mapAttributeType)) {
      setMapAttribute(mapAttributeList[0]);
    }
  },[mapAttributeList]);

  const handleChange = (event: SelectChangeEvent<MapAttributeType>) => {
    const newMapAttributeType = event.target.value;
    const newMapAttribute = mapAttributeList.find((mapAttribute) => mapAttribute.type === newMapAttributeType);
    if (!newMapAttribute) {
      throw new Error(`Map attribute ${newMapAttributeType} not found`);
    }
    setMapAttribute(newMapAttribute);
    
    // Send event to Google Analytics
    ReactGA.event('select_map_attribute', {
      category: 'Map',
      action: 'Select Map Attribute',
      value: newMapAttribute.type,
    });
  };

  const groupedMenu = mapAttributeList.reduce((acc: { [key: string]: Array<MapAttribute> }, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  return (
    <FormControl>
      <InputLabel id='map-attribute-select-label'>Map Attribute</InputLabel>
      <Select
        defaultValue={defaultMapAttribute}
        labelId='map-attribute-select-label'
        onChange={handleChange}
        size={'medium'}
        value={mapAttributeType}
        variant='standard'
        sx={{ width: 270 }}
      >
        {Object.keys(groupedMenu).map((category, ci) => [
          <ListSubheader key={category}>{category}</ListSubheader>,
          ...groupedMenu[category].map((mapAttribute) => (
            <MapAttributeMenuItem key={mapAttribute.type} value={mapAttribute.type} mapAttribute={mapAttribute}>
              {mapAttributeItem(mapAttribute)}
            </MapAttributeMenuItem>
          )),
          (ci != Object.keys(groupedMenu).length-1) && <Divider />
        ])}
      </Select>
    </FormControl>
  );
};
